const mutations = {
    setLeaveRequests(state,payload) {
        state.leaveRequests = payload
    },
    setLeaveRequest(state,payload) {
        state.leaveRequest = payload
    }
}

export default mutations

